import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

function Splash() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--nav-bg)',
      paddingTop: 'var(--sat)',
      paddingBottom: 'var(--sab)',
      animation: 'fade-in 0.2s ease both',
    }}>
      <span style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 800,
        fontSize: '2.5rem',
        letterSpacing: '-0.03em',
        color: 'var(--nav-text)',
      }}>
        Chor<i className="title-italics">tl</i><span className="title-tail">e</span>
      </span>
    </div>
  );
}

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <Splash />;
  if (!isAuthenticated) return <Navigate to="/signin" replace />;

  return <Outlet />;
}
